import axios from "axios";
import { getAuth } from "firebase/auth";
import Question from "../models/Question.js";

const BASE_URL = "https://europe-west3-hyper-e122e.cloudfunctions.net";
const UPDATE_URL = "https://europe-west3-hyper-e122e.cloudfunctions.net/update_question_or_answer_stat";
const CREATE_ANSWER_URL = `${BASE_URL}/create_answer`;

export default class QuestionService {

  static async fetchQuestions() {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;

      if (!currentUser) throw new Error("❌ Пользователь не авторизован");

      const token = await currentUser.getIdToken(true);

      const response = await axios.get(`${BASE_URL}/get_questions`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response.data;

      if (data.status === "success") {
        console.log("📦 Полученные данные с бэка:", data.questions);
        return Question.fromArray(data.questions);
      } else {
        throw new Error(data.message || "Неизвестная ошибка при получении вопросов");
      }
    } catch (error) {
      console.error("❌ Ошибка загрузки вопросов:", error.message);
      throw error;
    }
  }

  static async updateStat({ docId, collection, field, operation }) {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;

      if (!currentUser) throw new Error("❌ Пользователь не авторизован");

      const token = await currentUser.getIdToken(true);

      const response = await axios.post(
        UPDATE_URL,
        {
          doc_id: docId,
          collection,
          field,
          operation,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("✅ Статистика обновлена:", response.data);
      return response.data;
    } catch (error) {
      console.error("❌ Ошибка при обновлении статистики:", error.message);
      throw error;
    }
  }

    static async createAnswer(questionId, answerText) {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;

      if (!currentUser) throw new Error("❌ Пользователь не авторизован");

      const token = await currentUser.getIdToken(true);

      const response = await axios.post(
        CREATE_ANSWER_URL,
        {
          question_id: questionId,
          answer: answerText,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("📝 Ответ успешно создан:", response.data);
      return response.data;
    } catch (error) {
      console.error("❌ Ошибка при создании ответа:", error.message);
      throw error;
    }
  }

}